import * as React from 'react';
import { Colors } from '../colors';
import { HatchPatternId, getHatchPatternFill } from '../Patterns';

interface Props {
  children: React.ReactNode;
  variant: 'disputable' | 'non-disputable';
  isPast?: boolean;
}

export const Symbol: React.FC<Props> = (props) => {
  const { children, variant, isPast } = props;
  return (
    <div
      className="rounded flex items-center h-5"
      style={{ background: variant === 'disputable' ? Colors.Disputable : Colors.NonDisputable }}
    >
      {isPast && (
        <svg height="100%" width="20px">
          <rect
            width="100%"
            height="100%"
            fill={getHatchPatternFill(
              variant === 'disputable' ? HatchPatternId.Disputable : HatchPatternId.NonDisputable
            )}
          />
        </svg>
      )}
      <div className="px-3 py-1 text-center">
        <h6 className="text-white font-medium">{children}</h6>
      </div>
    </div>
  );
};
Symbol.displayName = 'GraphTooltip.Symbol';
